// app/unlock/actions.ts
'use server'

import { cookies } from "next/headers";

export async function unlockBeta(password: string) {
  const correctPassword = process.env.BETA_PASSWORD;

  if (password === correctPassword) {
    const cookieStore = await cookies();
    cookieStore.set("beta_unlock_key", password, {
      httpOnly: true,
      secure: process.env.NODE_ENV === "production",
      sameSite: "lax",
      maxAge: 60 * 60 * 24 * 30,
      path: "/",
    });
    return { success: true };
  }

  return { success: false, error: "Invalid access code" };
}